/**
 * 屏幕自适应rem方案
 * 基于1440px设计稿
 */

// 设置基准值
const BASE_WIDTH = 1440; // 设计稿宽度
const BASE_FONT_SIZE = 16; // 默认字体大小

/**
 * 根据屏幕宽度计算rem单位
 */
function setRemUnit() {
  const html = document.documentElement;
  const clientWidth = html.clientWidth;
  
  // 计算rem基准值
  // 当屏幕宽度小于1440时，按1440计算；大于1440时，按比例放大
  let effectiveWidth = Math.max(clientWidth, BASE_WIDTH);
  // let remUnit = (clientWidth / BASE_WIDTH) * BASE_FONT_SIZE;
  let remUnit = (effectiveWidth / BASE_WIDTH) * BASE_FONT_SIZE;
  
  // 设置html的font-size
  html.style.fontSize = `${remUnit}px`;
}

/**
 * 初始化rem适配
 */
function initRemAdapter() {
  // 初始设置
  setRemUnit();
  
  // 监听窗口大小变化
  window.addEventListener('resize', () => {
    // 使用防抖优化性能
    clearTimeout(window.remResizeTimer);
    window.remResizeTimer = setTimeout(() => {
      setRemUnit();
    }, 300);
  });
  
  // 监听方向变化（移动端）
  window.addEventListener('orientationchange', () => {
    setTimeout(setRemUnit, 300);
  });
}

// 导出函数供外部使用
export {
  setRemUnit,
  initRemAdapter
};

// 自动初始化
if (typeof window !== 'undefined') {
  initRemAdapter();
}